(function () {
  if (window.__wwCart) return;
  window.__wwCart = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nf = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents) { return '$ ' + nf.format(Math.round(cents) / 100); }
  var S = null; // estado anterior: { pct, p1, r1, r2, total, save, amt, stage }
  var lost1 = false, lost2 = false, rafA = 0, rafS = 0, shownA = null, shownS = null;

  function drawer() { return document.querySelector('cart-drawer.ww-cart'); }
  function read(root) {
    var d = root && root.querySelector('.ww-data');
    if (!d) return null;
    return {
      pct: parseFloat(d.dataset.pct) || 0, p1: parseFloat(d.dataset.p1) || 0,
      r1: d.dataset.r1 === 'true', r2: d.dataset.r2 === 'true', total: +d.dataset.total || 0,
      save: +d.dataset.save || 0, cel: d.dataset.cel === 'true', t1: +d.dataset.t1 || 0, t2: +d.dataset.t2 || 0,
      lost1: d.dataset.lost1, lost2: d.dataset.lost2
    };
  }
  function count(el, from, to, kind) {
    if (!el) return;
    if (reduce || from === null || from === to) { el.textContent = money(to); return; }
    var t0 = performance.now(), D = 850;
    function step(now) {
      var k = Math.min(1, (now - t0) / D), e = 1 - Math.pow(1 - k, 4), v = from + (to - from) * e;
      el.textContent = money(v);
      if (kind === 'a') shownA = v; else shownS = v;
      if (k < 1) { if (kind === 'a') rafA = requestAnimationFrame(step); else rafS = requestAnimationFrame(step); }
    }
    if (kind === 'a') { cancelAnimationFrame(rafA); rafA = requestAnimationFrame(step); } else { cancelAnimationFrame(rafS); rafS = requestAnimationFrame(step); }
  }
  function confetti(dot) {
    if (navigator.vibrate) { try { navigator.vibrate(28); } catch (e) {} }
    if (reduce || !dot) return;
    setTimeout(function () {
      var fx = document.getElementById('WWFx'), bar = document.getElementById('WWBar');
      if (!fx || !bar) return;
      var b = bar.getBoundingClientRect(), d = dot.getBoundingClientRect();
      var x = d.left + d.width / 2 - b.left, y = d.top + d.height / 2 - b.top;
      var colors = ['#1C1C1A', '#F2C230', '#FAF5EB', '#1C1C1A', '#F2C230', '#D6D4CE'];
      for (var i = 0; i < 22; i++) {
        var s = document.createElement('span'), c = colors[i % colors.length];
        s.className = 'ww-cf' + (i % 3 === 0 ? ' round' : '');
        var ang = (-160 + Math.random() * 140) * Math.PI / 180, dist = 40 + Math.random() * 70;
        s.style.left = x + 'px'; s.style.top = y + 'px'; s.style.background = c;
        if (c === '#FAF5EB') s.style.boxShadow = 'inset 0 0 0 1px #D6D4CE';
        s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
        s.style.setProperty('--dy', (Math.sin(ang) * dist + 28) + 'px');
        s.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
        s.style.animationDelay = (Math.random() * 60) + 'ms';
        fx.appendChild(s);
        setTimeout(function (n) { return function () { n.remove(); }; }(s), 1200);
      }
    }, 560);
  }
  function keepSummary(root) {
    var d = root && root.querySelector('#WWSum');
    if (!d) return;
    if (window.__wwSumOpen) d.open = true;
    if (!d.dataset.bound) { d.dataset.bound = '1'; d.addEventListener('toggle', function () { window.__wwSumOpen = d.open; }); }
  }
  function enhance() {
    var root = drawer();
    keepSummary(root);
    var N = read(root);
    if (!N) { S = null; shownA = shownS = null; return; }
    if (S === null) { // primera lectura: sin animación
      N.stage = !N.r1 ? 's1' : (N.t2 && !N.r2 ? 's2' : (N.r2 ? 'g' : 'd'));
      S = N; var a0 = root.querySelector('.ww-amt'); shownA = a0 ? +a0.dataset.cents : null; shownS = N.save; return;
    }
    if (N.total === S.total && N.pct === S.pct && N.r1 === S.r1 && N.r2 === S.r2) { S = N; return; }
    var fill = document.getElementById('WWFill');
    var d1 = document.getElementById('WWDot1'), d2 = document.getElementById('WWDot2');
    // barra: arranca donde estaba y se desliza al nuevo punto
    if (fill && !reduce) {
      fill.style.transition = 'none'; fill.style.width = S.pct + '%';
      if (d1) { d1.style.transition = 'none'; d1.style.left = S.p1 + '%'; if (N.r1 && !S.r1) d1.classList.remove('on'); }
      if (d2 && N.r2 && !S.r2) { d2.style.transition = 'none'; d2.classList.remove('on'); }
      void fill.offsetWidth;
      fill.style.transition = ''; fill.style.width = N.pct + '%';
      if (d1) { d1.style.transition = ''; d1.style.left = N.p1 + '%'; }
      if (d2) d2.style.transition = '';
      setTimeout(function () { if (d1 && N.r1) d1.classList.add('on'); if (d2 && N.r2) d2.classList.add('on'); }, N.r1 && !S.r1 || N.r2 && !S.r2 ? 480 : 0);
    }
    // pérdida de beneficio
    if (!N.r1 && S.r1) lost1 = true; if (N.r1) lost1 = false;
    if (N.t2 && !N.r2 && S.r2) lost2 = true; if (N.r2) lost2 = false;
    var msg = document.getElementById('WWMsg'), amt = root.querySelector('.ww-amt');
    if (msg && amt && ((lost1 && !N.r1) || (lost2 && N.r1 && !N.r2))) {
      var tpl = (!N.r1 ? N.lost1 : N.lost2) || '';
      var k = tpl.indexOf('[monto]');
      if (k > -1) { msg.textContent = tpl.slice(0, k); msg.appendChild(amt); msg.appendChild(document.createTextNode(tpl.slice(k + 7))); }
    }
    var stage = !N.r1 ? (lost1 ? 'l1' : 's1') : (N.t2 && !N.r2 ? (lost2 ? 'l2' : 's2') : (N.r2 ? 'g' : 'd'));
    if (msg && stage !== S.stage) { msg.classList.remove('swap'); void msg.offsetWidth; msg.classList.add('swap'); shownA = null; }
    if (amt) count(amt, shownA, +amt.dataset.cents, 'a'); else shownA = null;
    // celebración
    var win = document.getElementById('WWWin');
    if (N.cel && win && ((N.r1 && !S.r1 && win.dataset.kind === 'ship') || (N.r2 && !S.r2))) {
      win.classList.remove('is-compact'); win.classList.add('enter');
      confetti(N.r2 && !S.r2 ? d2 : d1);
      clearTimeout(window.__wwShrink);
      window.__wwShrink = setTimeout(function () { var w = document.getElementById('WWWin'); if (w) { w.classList.remove('enter'); w.classList.add('is-compact'); } }, 3200);
    }
    // ahorro
    var sv = document.getElementById('WWSaved'), sa = root.querySelector('.ww-save-amt');
    if (sa) {
      count(sa, shownS, N.save, 's');
      if (sv && N.save > S.save + 1 && S.save > 0 && !reduce) { sv.classList.remove('bump'); void sv.offsetWidth; sv.classList.add('bump'); }
    } else { shownS = null; }
    N.stage = stage; S = N;
    try { document.dispatchEvent(new CustomEvent('ww:cart-updated', { detail: { total: N.total } })); } catch (e) {}
  }
  function boot() {
    var root = drawer();
    if (!root) return;
    S = null; enhance();
    var pending = false;
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && n.classList.contains('ww-cf')); });
      });
      if (!relevant || pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; enhance(); });
    }).observe(root, { childList: true, subtree: true });

    // "−" con cantidad mínima: quita el producto en lugar de marcar error
    root.addEventListener('click', function (e) {
      var m = e.target.closest('.ww-qty .quantity__button[name=minus]');
      if (!m) return;
      var inp = m.parentElement.querySelector('input');
      if (!inp) return;
      var min = parseInt(inp.dataset.min || '1', 10) || 1;
      if (parseInt(inp.value, 10) <= min) {
        e.preventDefault(); e.stopImmediatePropagation();
        var item = m.closest('.ww-item'), rmb = item && item.querySelector('cart-remove-button');
        if (rmb) rmb.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    }, true);

    // cantidad en 0 (escrita o por botón): quitar el producto en lugar de mostrar el aviso de mínimo
    function removeFor(input) {
      var item = input.closest('.ww-item'), rmb = item && item.querySelector('cart-remove-button');
      if (rmb) rmb.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
    root.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || !inp.matches || !inp.matches('.ww-qty .quantity__input')) return;
      var v = parseInt(inp.value, 10);
      if (isNaN(v) || v <= 0) {
        e.stopImmediatePropagation();
        try { inp.setCustomValidity(''); } catch (err) {}
        removeFor(inp);
      }
    }, true);
    root.addEventListener('invalid', function (e) { if (e.target.closest && e.target.closest('.ww-qty')) e.preventDefault(); }, true);

    // agregar sugerencias sin salir del carrito
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ww-add], [data-ww-add-select]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.dataset.wwAdd;
      if (!id) { var sel = btn.parentElement.querySelector('select'); id = sel && sel.value; }
      if (!id) return;
      btn.setAttribute('aria-busy', 'true');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.sections && root.renderContents) { root.renderContents(res); }
        else { btn.removeAttribute('aria-busy'); }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ww-upsell', productVariantId: +id }); } catch (err) {} }
      }).catch(function () { btn.removeAttribute('aria-busy'); });
    });

    // cerrar deslizando hacia la derecha (celular)
    var sx = 0, sy = 0, dx = 0, drag = false;
    root.addEventListener('touchstart', function (e) {
      var inner = e.target.closest('.drawer__inner'); if (!inner) return;
      if (e.target.closest('.ww-ups__list, input, select')) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; drag = true;
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
      if (Math.abs(my) > Math.abs(mx) && Math.abs(dx) < 6) { drag = false; return; }
      dx = Math.max(0, mx);
      var inner = root.querySelector('.drawer__inner');
      root.classList.add('dragging'); inner.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });
    root.addEventListener('touchend', function () {
      if (!drag) return; drag = false;
      var inner = root.querySelector('.drawer__inner');
      root.classList.remove('dragging'); inner.style.transform = '';
      if (dx > 80 && root.close) root.close();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
